module.exports = __webpack_public_path__ + "static/img/spring_pipa.ae2ae66b.png";